<script>
import ProgressBar from './ProgressBar.vue'

export default {
  name: 'Player',
  components: { ProgressBar },
  props: {
    src: {
      type: String,
      default: ''
    },
    preload: {
      type: String,
      default: 'auto'
    }
  },
  data() {
    return {
      currentTime: 0,
      duration: 0,
      progressChanging: false,
      playing: false
    }
  },
  computed: {
    progress() {
      return this.currentTime / this.duration
    },
    currentTimeFormat() {
      return this.formatTime(this.currentTime)
    }
  },
  methods: {
    onProgressChanging(progress) {
      this.progressChanging = true
      this.currentTime = this.duration * progress
    },
    onProgressChanged(progress) {
      this.progressChanging = false
      this.$refs.audioRef.currentTime = this.currentTime = this.duration * progress
    },
    updateTime(e) {
      if (!this.progressChanging) {
        this.duration = e.target.duration
        this.currentTime = e.target.currentTime
      }
    },
    loadedmetadata(e) {
      this.duration = e.target.duration
    },
    formatTime(interval) {
      interval = interval | 0
      const minute = ((interval / 60 | 0) + '').padStart(2, '0')
      const second = (interval % 60 + '').padStart(2, '0')
      return `${minute}:${second}`
    },
    onPlay() {
      this.playing = true
      this.$refs.audioRef.play()
    },
    onPause() {
      this.playing = false
      this.$refs.audioRef.pause()
    },
    onEnded(e) {
      e.target.currentTime = 0
      this.playing = false
      this.$emit('ended')
    },
    toggleFullScreen() {
      const elem = this.$refs.audioRef
      elem.controls = false
      if (!document.fullscreenElement) {
        // 进入全屏
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen()
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen()
        }
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen()
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen()
        }
      }
    }
  }
}
</script>

<template>
  <div class="relative player">
    <video
      width="100%"
      ref="audioRef"
      webkit-playsinline='true'
      playsinline='true'
      x5-video-player-type="h5-page"
      @timeupdate="updateTime"
      :src="src"
      :preload="preload"
      @loadedmetadata="loadedmetadata"
      @ended="onEnded"
    ></video>
    <div class="wrapper">
      <span v-if="playing" class="cursor-pointer" @click="onPause">
<!--        <i class="el-icon-video-pause"></i>-->
         <van-icon name="pause"></van-icon>
      </span>
      <span v-else class="cursor-pointer" @click="onPlay">
<!--        <i class="el-icon-video-play"></i>-->
        <van-icon name="play"></van-icon>
      </span>
      <span class="time time-l ml-2" :key="currentTime">{{ currentTimeFormat }}</span>
      <div class="progress-bar-wrapper">
        <progress-bar
          ref="barRef"
          :progress="progress"
          @progress-changing="onProgressChanging"
          @progress-changed="onProgressChanged"
        >
        </progress-bar>
      </div>
      <span class="time time-r">{{ formatTime(duration) }}</span>
      <span class="ml-2" @touchend="toggleFullScreen">
        <van-icon name="enlarge" />
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.player {
  padding-bottom: 50px;
}

.wrapper {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 2px;
  padding: 8px;
  margin: 8px 0;

  .time {
    color: #000;
    font-size: 12px;
    flex: 0 0 40px;
    line-height: 30px;
    width: 40px;

    &.time-l {
      text-align: left;
    }

    &.time-r {
      text-align: right;
    }
  }

  .progress-bar-wrapper {
    flex: 1;
  }
}

.wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

video::-webkit-media-controls-timeline,
video::-moz-range-progress,
video::-ms-fill-lower {
  display: none;
}
</style>
